import { getFormattedIndex, parseHtml } from "@/utils/common";
import styles from "./style.module.scss";

interface Actor {
  id: string | number;
  title: string;
  description: string;
}

interface UseCaseActorsProps {
  block: {
    title: string;
    Actors?: Actor[];
  };
}

const UseCaseActors: React.FC<UseCaseActorsProps> = ({ block }) => {
  return (
    <>
      <section className="pb-[36px] lg:pb-[46px] xl:pb-[56px] bg-white max-w-[1020px] mx-auto">
        <div className="container">
          <div className={styles.useCaseNew}>
            <h2>{block.title ?? ""}</h2>
            {block?.Actors?.map((actor, index) => (
              <div
                key={actor.id || index}
                className="relative border border-[#B0D9F7] bg-white p-[50px_24px_24px_24px] xl:p-[65px_24px_24px_24px] mt-[70px]"
              >
                {/* Number badge */}
                <div className="absolute top-[-30px] xl:top-[-40px] left-[24px] xl:w-[80px] xl:h-[80px] w-[60px] h-[60px] border-[#B0D9F7] border flex items-center justify-center bg-[#E6F3FD]              ">
                  <h6 className="font-bold text-blue-900 text-subtitle-1">
                    {getFormattedIndex(index + 1)}
                  </h6>
                </div>

                {/* Content */}
                <h3 className="font-bold text-primary-text text-[18px] md:text-[22px]  xl:text-[24px] leading-[22.2px] md:leading-[26.2px] xl:leading-[31.2px] mb-[12px]">
                  {actor.title}
                </h3>
                <p className="font-regular text-subtitle-2 text-primary-text !mb-[0]">
                  {actor.description ? parseHtml(actor.description) : ""}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default UseCaseActors;
